import {
  call, put, takeEvery,
} from 'redux-saga/effects';
import {
  fetchDatasetLinksError,
  fetchDatasetLinksSuccess,
} from '../actions';
import actions from '../constants';
import DatasetLinkService from '../service';

function fetchDatasetLinks(code) {
  return DatasetLinkService.links(code)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

export function* links(action) {
  const { response, error } = yield call(fetchDatasetLinks, action.code);
  if (error) {
    yield put(fetchDatasetLinksError(action.category, action.code, error));
  } else {
    yield put(fetchDatasetLinksSuccess(action.category, action.code, response));
  }
}

export default function* datasetLinksApi() {
  yield takeEvery(actions.FETCH_DATASET_LINKS, links);
}
